import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Équipements de quai & Maintenance industrielle | ORION INDUSTRIE",
  description = "ORION INDUSTRIE : équipements de quai (ponts, niveleurs, butoirs) et maintenance industrielle (soudage, réparation). Intervention nationale. Installations conformes aux normes de sécurité.",
  keywords = "équipements de quai, maintenance industrielle, soudage industriel, ponts de chargement, niveleurs hydrauliques, butoirs quai, réparation métallique, installation sécurisée, sécurité industrielle, intervention sur site",
  url = "https://www.orion-industrie.eu",
  image = "https://www.orion-industrie.eu/orion-logo.png"
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
